// extracted by mini-css-extract-plugin
export default {"ExpertSection":"Style_ExpertSection__F137N","MainSection":"Style_MainSection__hSvt-"};